"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * QVET API Contracts
 */
__exportStar(require("./mirrored-entity"), exports);
__exportStar(require("./responses"), exports);
__exportStar(require("./purchase-invoices"), exports);
__exportStar(require("./purchase-orders"), exports);
__exportStar(require("./suppliers"), exports);
__exportStar(require("./payables"), exports);
__exportStar(require("./delivery-notes"), exports);
__exportStar(require("./staff"), exports);
__exportStar(require("./pets"), exports);
__exportStar(require("./visits"), exports);
__exportStar(require("./client-duplicates"), exports);
__exportStar(require("./inventory-sections"), exports);
__exportStar(require("./warehouses"), exports);
__exportStar(require("./hvp-data"), exports);
__exportStar(require("./write-cycle"), exports);
__exportStar(require("./staff-links"), exports);
